import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IGetValueAsPromiseRequestPayload } from '../models/models';

@Injectable({
  providedIn: 'root'
})
export class GeneralApiService {

  constructor(private http: HttpClient) { }

  /**
   * This function is called to get value from validator wrapper class
   * @param requestPayload
   */
  getValue(requestPayload: IGetValueAsPromiseRequestPayload): Observable<string> {
    return this.http
      .post(`${environment.api.url}/WebServices/DefendantInfo.asmx/GetValue`, requestPayload, {
        params: { showLoader: 'true' },
      })
      .pipe(
        map((res: any) => {
          var Value = res;
          return Value;
        })
      );
  }
  
}
